

document.querySelectorAll('[data-benefits-slider]').forEach((slider) => {

  const section = slider.closest('.benefits-media');

  if (!section) return;

  const slides = slider.querySelectorAll('.benefits-media__slide');

  const prevButton = section.querySelector('[data-benefits-prev]');
  const nextButton = section.querySelector('[data-benefits-next]');
  const currentCounter = section.querySelector('[data-benefits-current]');

  if (slides.length <= 1) return;

  let currentIndex = 0;

  let startX = 0;
  let startY = 0;
  let isTouching = false;
  let isMouseDragging = false;

  const SWIPE_THRESHOLD = 50;


  function showSlide(index) {

     /* Stop at the first slide */
  if (index < 0) {
    index = 0;
  }

  /* Stop at the last slide */
  if (index >= slides.length) {
    index = slides.length - 1;
  }


    /* =========================================
     * UPDATE ACTIVE SLIDE
     * ========================================= */

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    currentIndex = index;


    /* =========================================
     * UPDATE ARROW COLORS
     * ========================================= */

    if (prevButton && nextButton) {


       /* Reset both buttons */

      prevButton.disabled = false;
      nextButton.disabled = false;

      prevButton.classList.remove('is-disabled');
      nextButton.classList.remove('is-disabled');

      prevButton.style.cursor = 'pointer';
      nextButton.style.cursor = 'pointer';


      /* FIRST SLIDE */

      if (currentIndex === 0) {

        prevButton.disabled = true;
        prevButton.classList.add('is-disabled');

        prevButton.style.color = '#6E6969';
        prevButton.style.cursor = 'not-allowed';

        nextButton.disabled = false;
        nextButton.classList.remove('is-disabled');

        nextButton.style.color = '#5C5757';
        nextButton.style.cursor = 'pointer';

      }

      /* LAST SLIDE */

      else if (currentIndex === slides.length - 1) {

         nextButton.disabled = true;
         nextButton.classList.add('is-disabled');

         nextButton.style.color = '#6E6969';
         nextButton.style.cursor = 'not-allowed';

         prevButton.disabled = false;
         prevButton.classList.remove('is-disabled');

         prevButton.style.color = '#5C5757';
         prevButton.style.cursor = 'pointer';



      }

      /* MIDDLE SLIDES */

      else {

        prevButton.style.color = '#5C5757';
        nextButton.style.color = '#5C5757';

      }

    }


    /* =========================================
 * DYNAMIC COTENT
 * ========================================= */

if (section.dataset.benefitsBehavior === 'dynamic') {

  /* =========================================
   * DYNAMIC HEADING
   * ========================================= */

  const dynamicHeading = section.querySelector(
    '[data-dynamic-heading]'
  );

  if (dynamicHeading) {

    const activeSlide = slides[index];

    const slideHeading = activeSlide.querySelector(
      '[data-slide-heading]'
    );

    if (slideHeading) {
      dynamicHeading.innerHTML = slideHeading.innerHTML;
    } else {
      dynamicHeading.innerHTML = '';
    }

  }

    /* =========================================
 * DYNAMIC BENEFITS
 * ========================================= */

  const dynamicBenefits = section.querySelector(
    '[data-dynamic-benefits]'
  );

  if (dynamicBenefits) {

    const activeSlide = slides[index];

    const slideBenefits = activeSlide.querySelector(
      '[data-slide-benefits]'
    );

    if (slideBenefits) {
      dynamicBenefits.innerHTML = slideBenefits.innerHTML;
    } else {
      dynamicBenefits.innerHTML = '';
    }

  }


  /* =========================================
   * DYNAMIC DESCRIPTION
   * ========================================= */

  const dynamicDescription = section.querySelector(
    '[data-dynamic-description]'
  );

  if (dynamicDescription) {

    const activeSlide = slides[index];

    const slideDescription = activeSlide.querySelector(
      '[data-slide-description]'
    );

    if (slideDescription) {
      dynamicDescription.innerHTML = slideDescription.innerHTML;
    } else {
      dynamicDescription.innerHTML = '';
    }

  }

}


    /* =========================================
     * UPDATE COUNTER
     * ========================================= */

    if (currentCounter) {
      currentCounter.textContent = currentIndex + 1;
    }


    /* =========================================
     * PAUSE / PLAY VIDEOS
     * ========================================= */

    slides.forEach((slide, i) => {

      const video = slide.querySelector('video');

      if (!video) return;

      if (i === currentIndex) {

        video.play().catch(() => {});

      } else {

        video.pause();

      }

    });

  }


  /*
   * =========================
   * PREVIOUS BUTTON
   * =========================
   */

  if (prevButton) {

    prevButton.addEventListener('click', () => {

      showSlide(currentIndex - 1);

    });

  }


  /*
   * =========================
   * NEXT BUTTON
   * =========================
   */

  if (nextButton) {

    nextButton.addEventListener('click', () => {

      showSlide(currentIndex + 1);

    });

  }


  /*
   * =========================
   * TOUCH START
   * =========================
   */

  slider.addEventListener('touchstart', (event) => {

    if (!event.touches.length) return;

    const touch = event.touches[0];

    startX = touch.clientX;
    startY = touch.clientY;

    isTouching = true;

  }, { passive: true });


  /*
   * =========================
   * TOUCH END
   * =========================
   */

  slider.addEventListener('touchend', (event) => {

    if (!isTouching || !event.changedTouches.length) {
      return;
    }

    const touch = event.changedTouches[0];

    const deltaX = touch.clientX - startX;
    const deltaY = touch.clientY - startY;

    isTouching = false;


    /*
     * Vertical movement
     */

    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      return;
    }


    /*
     * Ignore small movements
     */

    if (Math.abs(deltaX) < SWIPE_THRESHOLD) {
      return;
    }


    /*
     * Swipe left = next
     * Swipe right = previous
     */

    if (deltaX < 0) {

      showSlide(currentIndex + 1);

    } else {

      showSlide(currentIndex - 1);

    }

  }, { passive: true });


  /*
   * =========================
   * DESKTOP MOUSE DRAG
   * =========================
   */

  slider.addEventListener('mousedown', (event) => {

    if (event.button !== 0) return;

    startX = event.clientX;
    startY = event.clientY;

    isMouseDragging = true;

    slider.classList.add('is-dragging');

    event.preventDefault();

  });


  slider.addEventListener('mouseup', (event) => {

    if (!isMouseDragging) return;

    const deltaX = event.clientX - startX;
    const deltaY = event.clientY - startY;

    isMouseDragging = false;

    slider.classList.remove('is-dragging');


    /*
     * Ignore vertical dragging
     */

    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      return;
    }


    /*
     * Ignore small movements
     */

    if (Math.abs(deltaX) < SWIPE_THRESHOLD) {
      return;
    }


    /*
     * Drag left = next
     * Drag right = previous
     */

    if (deltaX < 0) {

      showSlide(currentIndex + 1);

    } else {

      showSlide(currentIndex - 1);

    }

  });


  slider.addEventListener('mouseleave', () => {

    if (!isMouseDragging) return;

    isMouseDragging = false;

    slider.classList.remove('is-dragging');

  });


  /*
   * Prevent native image dragging
   */

  slider.addEventListener('dragstart', (event) => {

    event.preventDefault();

  });


  /*
   * =========================
   * INITIAL SLIDE
   * =========================
   */

  showSlide(0);

});